import React from "react";
import Header from "../Header";
import BaseContainerDividingLineRHSSidebar from "../BaseContainerDividingLineRHSSidebar";
import EditProfileButton from "../EditProfileButton";
import ChangePlanButton from "../ChangePlanButton";
import PasswordAndSecurityButton from "../PasswordAndSecurityButton";
import NotificationsButton from "../NotificationsButton";
import rect6518 from "../../img/rectangle-6518@2x.svg"
import changeLogo from "../../img/group-1000006368@2x.svg"
import "./ChangePlanPage.css";

const ChangePlanPage = () => {

    return (
        <div className="container-center-horizontal">
            <div className="change-plan-home-page screen">
                <div className="flex-col">
                    <Header />
                    <div className="overlap-group2">
                        <BaseContainerDividingLineRHSSidebar />
                        <div className="rectangle-6452 border-1px-athens-gray-2"></div>
                        <div className="rectangle-6457 border-1px-athens-gray-2"></div>
                        <div className="profile nunito-bold-black-30px">Profile</div>
                        <div className="change-plan">
                            <div className="change-plan-1 nunito-bold-black-20px">Change Plan</div>
                        </div>
                        <img className="selected-icon-change-plan" src={rect6518} />
                        <EditProfileButton />
                        <ChangePlanButton className="nunito-bold-azure-radiance-14px" logo={changeLogo} />
                        <PasswordAndSecurityButton />
                        <NotificationsButton />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChangePlanPage;